import { createFileRoute } from "@tanstack/react-router";
import { Samples } from "@/fla/Samples";
import { AppHeader } from "@/components/wb/AppHeader";

export const Route = createFileRoute("/_app/fla/samples")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <AppHeader names={[{ name: "Samples" }]} />
      <Samples />
    </>
  );
}
